import { useFormikContext } from 'formik'

import { NOTIFICATION_TYPE } from '../../../../../constants/common'
import { getQaSelector } from '../../../../../utils/common'
import { NotificationInline } from '../../../../Notification'
import { QA_NAME_VIEWING_FORM_ERROR } from '../../RentalPortalViewingFormModal.constants'
import { getViewingFormErrorText } from '../../RentalPortalViewingFormModal.utils.validation'

function ViewingFormErrorNotification() {
  const { errors, submitCount } = useFormikContext()

  const errorText = getViewingFormErrorText(errors)

  return errorText && submitCount > 0 ? (
    <NotificationInline
      {...getQaSelector({ value: QA_NAME_VIEWING_FORM_ERROR })}
      text={errorText}
      type={NOTIFICATION_TYPE.error}
    />
  ) : null
}

export default ViewingFormErrorNotification
